import { __decorate } from "tslib";
import { QInput } from 'quasar';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ESetPoint } from '@sicfe/rooms/types';
let Room = class Room extends Vue {
    constructor() {
        super(...arguments);
        this.ESetPoints = ESetPoint;
    }
    displayValue(k, v) {
        if (k === ESetPoint.TemperatureMode) {
            switch (v.toLowerCase()) {
                case `off`:
                    return this.$t('sharedText.terms.off');
                case `heating low`:
                    return this.$t('sharedText.terms.heating_low');
                case `heating medium`:
                    return this.$t('sharedText.terms.heating_medium');
                case `heating high`:
                    return this.$t('sharedText.terms.heating_high');
                case `cooling low`:
                    return this.$t('sharedText.terms.cooling_low');
                case `cooling medium`:
                    return this.$t('sharedText.terms.cooling_medium');
                case `cooling high`:
                    return this.$t('sharedText.terms.cooling_high');
            }
        }
        const f = parseFloat(v);
        if (isNaN(f)) {
            return v;
        }
        if (k === ESetPoint.PowerSetpoint || k === ESetPoint.LightSetpoint) {
            if (f) {
                return this.$t('sharedText.terms.on');
            }
            else {
                return this.$t('sharedText.terms.off');
            }
        }
        return v;
    }
};
__decorate([
    Prop({ required: true, type: Object })
], Room.prototype, "room", void 0);
Room = __decorate([
    Component({
        components: {
            QInput,
        },
    })
], Room);
export default Room;
